import {T} from '../../utils/I18n/I18n';
import {useTranslation} from "react-i18next";
import clsx from 'clsx';
import React, {memo, useContext, useEffect} from 'react';
import {useCartContext} from '../../context/CartContext';
import {usePopup} from '../../context/PopupContext';
import useSetShippingMethod from '../../hooks/useSetShippingMethod';
import Prices from '../../components/BaseCurrencyPrices/Prices';

const CheckoutShippingOptions = ({ setIsDisabled, carrierCode, isChecked }) => {
  const { t } = useTranslation();
  const { cart } = useCartContext();
  const { showAddToCartPopupMessage } = usePopup();
  const { setShippingMethod, shippingMethodError, loading: setMethodLoading } = useSetShippingMethod();

  useEffect(() => {
    if (shippingMethodError) {
      showAddToCartPopupMessage(t('checkout.wrongAddress'), 'error', 4000);
    }
  }, [shippingMethodError]);

  if (!cart || cart.shipping_addresses.length === 0) {
    return null;
  }

  let currentMethod = cart.shipping_addresses[0].selected_shipping_method;
  const availableMethods = cart.shipping_addresses[0].available_shipping_methods;
  const filtered = availableMethods.filter(method => method.carrier_code === carrierCode);

  if (filtered.length == 1) {
    currentMethod = filtered[0]
  }
  const onChangeHandler = async event => {
    try {
      setIsDisabled(true);

      await setShippingMethod({
        carrier_code: carrierCode,
        method_code: event.target.value,
      });

      setIsDisabled(false);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="checkout__main__form__shipping">
      <div className="shipping-method-title">
        <T id="product.deliveryTab" />
      </div>

      {filtered.map(method => (
        <div key={method.method_code} className={clsx('shipping-method-radio', setMethodLoading && 'loading')}>
          <div className="shipping-method-radio__button">
            <input
              type="radio"
              name="method-code"
              id={method.method_code}
              value={method.method_code}
              onChange={onChangeHandler}
              disabled={setMethodLoading}
              defaultChecked={isChecked || (currentMethod && currentMethod.method_code === method.method_code)}
            />
          </div>

          <div className="shipping-method-radio__label">
            <label htmlFor={method.method_code}>
              <div className="shipping-method-radio__label--1">{method.method_title}</div>
              <div className="shipping-method-radio__label--2">{method.carrier_title}</div>
            </label>
          </div>

          <div className="shipping-method-radio__price">
            <Prices amount={method.amount.value} isMinicart breakRow />
          </div>
        </div>
      ))}
    </div>
  );
};

export default memo(CheckoutShippingOptions);
